(() => {
  let modalController;

  const addGlobalEventListeners = (callback, signal) => {
    const options = signal ? { signal } : undefined;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, options);
    } else {
      callback();
    }

    document.addEventListener('pagination:page-changed', callback, options);
    document.addEventListener('facet:render', callback, options);
    document.addEventListener('product-recommendations:loaded', callback, options);
    document.addEventListener('line-item:change:end', callback, options);
  };

  const initChainModalListeners = () => {
    // Abort previous listeners if they exist
    modalController?.abort();
    modalController = new AbortController();
    const { signal } = modalController;

    // Add listeners with abort signal - they'll be automatically removed when aborted
    document.addEventListener(
      'click',
      (e) => {
        // Handle open button clicks
        if (e.target.matches('[data-modal-kompatibilni-retizky-id]')) {
          const modal = document.getElementById(e.target.dataset.modalKompatibilniRetizkyId);
          modal?.showModal();
        }

        // Handle close button clicks
        if (e.target.matches('dialog.chain-suggestion__modal button[data-close-button]')) {
          e.target.closest('dialog')?.close();
        }

        // Handle backdrop clicks
        if (e.target.matches('dialog.chain-suggestion__modal')) {
          const rect = e.target.getBoundingClientRect();
          const isOutside = e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom;

          if (isOutside) e.target.close();
        }
      },
      { signal }
    );
  };
  console.log('Initializing chain modal listeners...');
  addGlobalEventListeners(initChainModalListeners);
})();
